'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CloseIcon = require('./CloseIcon');

var _CloseIcon2 = _interopRequireDefault(_CloseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CloseIcon2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CloseIcon/index.js
// module id = 261
// module chunks = 11